import { useModalStore, Modal } from '@/store/pinia/modalStore'

export const useConfirmationDialog = () => {
  const modalStore = useModalStore()
  const appConfirm = (
    msg: string,
    title: string = '',
    confirmationText: string = 'Confirm',
    type: 'info' | 'danger' = 'info',
    onConfirm: () => void = () => { },
    onCancel: () => void = () => { }
  ) => {
    return new Promise(resolve => {
      modalStore.openModal(Modal.ConfirmationModal, {
        msg,
        title,
        confirmationText,
        type,
        onConfirm, // This is a function that will be called when the user clicks the confirm button
        onCancel, // This is a function that will be called when the user clicks the cancel button
        resolve, // This resolves the promise to return a boolean value to the caller
      }, { keepOthers: true })
    })
  }
  return {
    appConfirm,
  }
}
